//configurar variável global
const protocol = window.location.protocol;
const hostname = window.location.hostname;
const port = window.location.port == 8081 ? 8080 : window.location.port;

export const base_url = `${protocol}//${hostname}:${port}`;
// export const base_url = `https://nota.macapa.ap.gov.br`;
